import * as dashboardActions from './constants.js'
import {handleRespErr} from '../../../helpers/respErrorsHandler'
import {API_URLS, buildAPIUrl} from "../../../urls";
import {toastError} from "../../../helpers/toaster";
import {GetAxios} from "../../../helpers/axios";


export function getPresale() {
    return dispatch => {

        let axios = GetAxios(dispatch);
        dispatch(getPresaleRequest());

        axios.get(buildAPIUrl(API_URLS.dashboard.presale),{
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then((res) => {
                dispatch(getPresaleSuccess(res.data));
            })
            .catch(handleRespErr(dispatch, toastError, getPresaleFailure))
    }
}


function getPresaleRequest() {
    return {
        type: dashboardActions.GET_PRESALE_REQUEST,
    }
}

function getPresaleSuccess(data) {
    return {
        type: dashboardActions.GET_PRESALE_SUCCESS,
        payload: data
    }
}

function getPresaleFailure(error) {
    return {
        type: dashboardActions.GET_PRESALE_FAILURE,
        error: error
    }
}


export function getDashboard() {
    return dispatch => {

        let axios = GetAxios(dispatch);
        dispatch(getDashboardRequest());

        axios.get(buildAPIUrl(API_URLS.dashboard.dashboard),{
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then((res) => {
                dispatch(getDashboardSuccess(res.data));
            })
            .catch(handleRespErr(dispatch, toastError, getDashboardFailure))
    }
}


function getDashboardRequest() {
    return {
        type: dashboardActions.GET_DASHBOARD_REQUEST,
    }
}

function getDashboardSuccess(data) {
    return {
        type: dashboardActions.GET_DASHBOARD_SUCCESS,
        payload: data
    }
}

function getDashboardFailure(error) {
    return {
        type: dashboardActions.GET_DASHBOARD_FAILURE,
        error: error
    }
}

export function getTopHolders(params) {
    return dispatch => {

        let axios = GetAxios(dispatch);
        dispatch(getTopHoldersRequest());

        axios.get(buildAPIUrl(API_URLS.dashboard.topHolders),{
            params,
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then((res) => {
                dispatch(getTopHoldersSuccess(res.data));
            })
            .catch(handleRespErr(dispatch, toastError, getTopHoldersFailure))
    }
}


function getTopHoldersRequest() {
    return {
        type: dashboardActions.GET_TOP_HOLDERS_REQUEST,
    }
}

function getTopHoldersSuccess(data) {
    return {
        type: dashboardActions.GET_TOP_HOLDERS_SUCCESS,
        payload: data
    }
}

function getTopHoldersFailure(error) {
    return {
        type: dashboardActions.GET_TOP_HOLDERS_FAILURE,
        error: error
    }
}


export function setDefaultDashboard() {
    return {
        type: dashboardActions.SET_DEFAULT_DASHBOARD
    }
}
export function setDefaultTopHolders() {
    return {
        type: dashboardActions.SET_DEFAULT_TOP_HOLDERS
    }
}
